import React from 'react';
import { useVwp } from '../VwpContext';
import Loading from "@ui/Loading";;
import SupplierCardCarousel from '../SupplierCardSlider/SupplierCardCarousel';
import SalePoints from '../SalePoints/SalePoints';
import ReviewSlider from '../ReviewSlider/ReviewSlider';
import AppBanner from '../AppBanner/AppBanner';

const PackageList = () => {
  const { isLoading, vwpCategories, vwpReviews, suppliersToHide, selectedPackageId, onPackageSelected } = useVwp();
  
  if (isLoading) {
    return (<div className="d-flex justify-content-center align-items-center" style={{minHeight: "10rem"}}>
        <Loading />
      </div>);
  }

  const categories = (!!suppliersToHide ? vwpCategories?.map(category => {
    const filteredPackages = category.Packages.filter(pkg => !suppliersToHide.includes(pkg.SupplierId));
    return {
        ...category,
        Packages: filteredPackages
    };
  }) : vwpCategories) || [];

  return (<>
    {categories?.map((category, index) => (<React.Fragment key={category.Id}>
      {index === 2 && <SalePoints />}
      {(index === 4 && !!vwpReviews) && <ReviewSlider reviews={vwpReviews} />}
      <SupplierCardCarousel
        key={category.Id+index}
        icon={category.Icon} // TODO: Use category icon
        category={category.Name}
        suppliers={category.Packages}
        onClick={onPackageSelected}
      />
    </React.Fragment>))}
    <AppBanner />
  </>);
};

export default PackageList;
